import { h } from "preact";
import { Typography } from "antd";


export default function VeriliveTransactionInfoDataSource(transactionInfo) {

    function asTableView() {
        return {
            columns: [
                {
                    dataIndex: "label",
                },
                {
                    dataIndex: "value",
                    render: (value) => (
                        <Typography.Text
                            type="secondary"
                        >
                            {value}
                        </Typography.Text>
                    ),
                },
            ],
            rows: [
                {
                    label: "Start Time",
                    value: transactionInfo?.start_time,
                },
                {
                    label: "End Time",
                    value: transactionInfo?.end_time,
                },
                {
                    label: "Status",
                    value: transactionInfo?.status,
                }
            ]
        };
    }

    function isEmpty() {

        const requiredFields = [
            "start_time",
            "end_time",
            "status"
        ];

        if (!transactionInfo) {
            return true;
        }

        return !requiredFields.every(field => (
            transactionInfo.hasOwnProperty(field)
        ));
    }

    return { asTableView, isEmpty };
}